import {ENV_STAGE, ENV_PROD} from '~/config/constants';

const baseParams = require('./config.json');
const envParamsStage = require('./config.stage.json');
const envParamsProd = require('./config.prod.json');

const getEnvParams = () => {
    switch (window.app.env) {
        case ENV_PROD:
            return envParamsProd;
        case ENV_STAGE:
            return envParamsStage;
        default:
            return {};
    }
}

export const Config = {
    params: {
        ...baseParams,
         ...getEnvParams(),
    },
    app: {
        version: undefined,
        env: undefined,
        ...window.app
    },
};
